import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { IsActiveMatchOptions, Router, RouterModule } from "@angular/router";

interface NavItem {
  name: string;
  icon: string;
  route?: string;
  heading?: boolean;
  children?: NavItem[];
}

const NAV_ITEMS: NavItem[] = [
  { name: "Overview", icon: "dashboard", route: "/dashboard" },
  {
    name: "Build",
    icon: "hub",
    children: [
      { name: "Patient Agents", icon: "medical_services", route: "/prototype/patient-agents" },
      { name: "Domain Agents", icon: "psychology", route: "/prototype/domain-agents" },
      { name: "Tools", icon: "build", route: "/prototype/placeholder/tools" },
      { name: "RAG Corpora", icon: "library_books", route: "/prototype/placeholder/rag" },
    ],
  },
  {
    name: "Simulate",
    icon: "forum",
    children: [
      { name: "Patient Agent Simulator", icon: "forum", route: "/prototype/patient-simulator" },
    ],
  },
  {
    name: "Release",
    icon: "rocket_launch",
    children: [
      { name: "Agent Release Pipeline", icon: "inventory_2", route: "/prototype/release/candidates" },
      { name: "Release Scorecard", icon: "verified", route: "/prototype/evaluation" },
      { name: "Approvals", icon: "how_to_reg", route: "/prototype/release/approvals" },
    ],
  },
  {
    name: "Evaluate",
    icon: "fact_check",
    children: [
      { name: "Test Suites", icon: "fact_check", route: "/prototype/test-suites" },
      { name: "Golden Datasets", icon: "dataset", route: "/lab/golden-datasets" },
      { name: "Expert Review", icon: "rate_review", route: "/prototype/review" },
    ],
  },
  {
    name: "Observe",
    icon: "monitor_heart",
    children: [
      { name: "Live Activity", icon: "bolt", route: "/observe/live" },
      { name: "Health", icon: "query_stats", route: "/prototype/placeholder/observe" },
    ],
  },
  {
    name: "Admin",
    icon: "admin_panel_settings",
    children: [
      { name: "Services & API Keys", icon: "vpn_key", route: "/prototype/services" },
      { name: "Audit Log", icon: "history", route: "/prototype/placeholder/audit" },
      { name: "Users & Roles", icon: "group", route: "/prototype/placeholder/users" },
      { name: "Legacy Management", icon: "tune", route: "/manage" },
      { name: "Classification", icon: "", heading: true },
      { name: "LLM Categories", icon: "category", route: "/prototype/classification/llm-categories" },
      { name: "Semantic Topics", icon: "hub", route: "/prototype/classification/semantic-topics" },
    ],
  },
];

const ACTIVE_OPTIONS: IsActiveMatchOptions = {
  paths: "subset",
  queryParams: "ignored",
  fragment: "ignored",
  matrixParams: "ignored",
};

@Component({
  selector: "app-side-nav",
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatIconModule, RouterModule],
  templateUrl: "./app-side-nav.component.html",
  styleUrl: "./app-side-nav.component.scss",
})
export class AppSideNavComponent {
  readonly items = NAV_ITEMS;
  private readonly router = inject(Router);

  isExpanded(item: NavItem) {
    return !!item.children?.some((child) => !!child.route && this.router.isActive(child.route, ACTIVE_OPTIONS));
  }
}
